<template>
  <div>
    <a-form :form="form" @submit="saveData">
      <a-divider orientation="left">账号信息</a-divider>
      <a-form-item
        label="客户编码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <!-- <a-input
          :disabled="true"
          v-decorator="[
            'code',
            {
              initialValue: tenantDetail.code,
              rules: [{ required: true, message: '请输入客户编码' }]
            }
          ]"
          placeholder="请输入客户编码"/> -->
        {{ tenantDetail.code }}
      </a-form-item>
      <a-form-item
        label="客户名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'name',
            {
              initialValue: tenantDetail.name,
              rules: [{ required: true, message: '请输入客户名称' }]
            }
          ]"
          placeholder="请输入客户名称"/>
      </a-form-item>
      <a-form-item
        label="联系人名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'contacts',
            {
              initialValue: tenantDetail.contacts,
              rules: [{ required: true, message: '请输入联系人名称' }]
            }
          ]"
          placeholder="请输入联系人名称"/>
      </a-form-item>
      <a-form-item
        label="联系人电话"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'contact_number',
            {
              initialValue: tenantDetail.contact_number,
              rules: [{ required: true, message: '请输入联系人电话' }]
            }
          ]"
          placeholder="请输入联系人电话"/>
      </a-form-item>
      <a-form-item
        label="登录账号"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <!-- <a-input
          :disabled="true"
          v-decorator="[
            'account',
            {
              initialValue: tenantDetail.admin_account,
              rules: [{ required: true, message: '请输入登录账号' }]
            }
          ]"
          placeholder="请输入登录账号"/> -->
        {{ tenantDetail.admin_account }}
      </a-form-item>
      <a-form-item
        label="登录密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          type="password"
          v-decorator="[
            'password'
          ]"
          placeholder="留空则不修改密码"/>
      </a-form-item>
      <a-form-item
        label="会员类型"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <!-- <a-radio-group v-model="tenantDetail.code_type" :disabled="true">
          <a-radio-button v-if="type.id !== ''" v-for="type in dict.codeTypeDict" :value="type.id" :key="type.id">{{ type.name }}</a-radio-button>
        </a-radio-group> -->
        {{ tenantDetail.code_type | valInDict(dict.codeTypeDict) }}
      </a-form-item>
      <a-form-item
        :required="true"
        label="账号状态"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-radio-group v-model="tenantDetail.status">
          <a-radio-button v-if="status.id !== ''" v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="业务经理"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="[
            'business_admin_id',
            {
              initialValue: tenantDetail.business_admin_id,
            }
          ]"
          placeholder="请选择">
          <a-select-option v-for="item in dict.businessManagerDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        :required="true"
        label="选择服务"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          mode="multiple"
          v-decorator="[
            'service',
            {
              initialValue: tenantDetail.service,
            }
          ]"
          placeholder="请选择服务">
          <a-select-option v-for="item in dict.serviceDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-divider orientation="left">企业信息</a-divider>
      <a-form-item
        label="企业全称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'system_name',
            {
              initialValue: tenantDetail.company_info.system_name,
            }
          ]"
          placeholder="请输入企业全称"/>
      </a-form-item>
      <a-form-item
        label="企业简称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'system_short_name',
            {
              initialValue: tenantDetail.company_info.system_short_name,
              rules: [{ required: true, message: '请输入企业简称' }]
            }
          ]"
          placeholder="请输入企业简称"/>
      </a-form-item>
      <a-form-item
        label="企业LOGO"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol">
        <a-upload
          name="file"
          :defaultFileList="fileList"
          listType="picture-card"
          class="avatar-uploader"
          :showUploadList="false"
          action="/admin.php/upload_file/uploadFile?type=tenant&local=YES"
          @change="handleChange"
        >
          <img v-if="logoUrl" :src="logoUrl" style="width:150px;" alt="LOGO" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item
        label="官网地址"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'system_url',
            {
              initialValue: tenantDetail.company_info.system_url
            }
          ]"
          placeholder="请输入官网地址"/>
      </a-form-item>
      <a-form-item
        label="联系电话"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              initialValue: tenantDetail.company_info.phone
            }
          ]"
          placeholder="请输入联系电话"/>
      </a-form-item>
      <a-form-item
        label="联系QQ"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'qq_number',
            {
              initialValue: tenantDetail.company_info.qq_number
            }
          ]"
          placeholder="请输入联系QQ"/>
      </a-form-item>
      <a-form-item
        label="联系邮箱"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'email',
            {
              initialValue: tenantDetail.company_info.email
            }
          ]"
          placeholder="请输入联系邮箱"/>
      </a-form-item>
      <a-form-item
        label="联系地址"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'address',
            {
              initialValue: tenantDetail.company_info.address
            }
          ]"
          placeholder="请输入联系地址"/>
      </a-form-item>
      <a-form-item :wrapperCol="{span: 12, offset: 9}">
        <a-button style="margin-right:20px" html-type="submit" type="primary" :loading="loading">保存</a-button>
        <a-button @click="onClose">取消</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { getPre, postUpdateTenant } from '@/api/tenant'
import { passwordEncryption } from '@/utils/util'
import _ from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tenantId: {
      type: Number,
      default: 0
    },
    tenantDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 抽屉加载
      loading: false,
      // 添加角色数据
      tenantData: {},
      dict: {},
      fileList: [],
      logoUrl: ''
    }
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.tenantData[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 图片上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const picUrl = _.get(info.file, 'response.data.url')
        this.tenantData[targetId] = path
        if (targetId === 'system_logo') {
          this.logoUrl = picUrl
        }
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleChange (info) {
      this.handleFileUpload(info, 'system_logo')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    // 抽屉保存按钮
    saveData (e) {
      e.preventDefault()
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.loading = true
          this.tenantData.tenant_id = this.tenantId
          this.tenantData.name = fieldsValue['name']
          this.tenantData.contacts = fieldsValue['contacts']
          this.tenantData.contact_number = fieldsValue['contact_number']
          this.tenantData.status = this.tenantDetail.status
          this.tenantData.business_admin_id = fieldsValue['business_admin_id']
          this.tenantData.service = fieldsValue['service']
          this.tenantData.account = this.tenantDetail.admin_account
          this.tenantData.system_name = fieldsValue['system_name']
          this.tenantData.system_short_name = fieldsValue['system_short_name']
          this.tenantData.qq_number = fieldsValue['qq_number']
          this.tenantData.address = fieldsValue['address']
          this.tenantData.phone = fieldsValue['phone']
          this.tenantData.email = fieldsValue['email']
          this.tenantData.system_url = fieldsValue['system_url']
          // console.log(fieldsValue['password']);
          if (fieldsValue['password'] !== '' && fieldsValue['password'] !== undefined) {
            this.tenantData.password = passwordEncryption(fieldsValue['password'])
          }
          this.tenantData.remark = fieldsValue['remark']
          postUpdateTenant(this.tenantData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.$message.success('保存成功')
              this.$emit('finish')
            } else {
              this.loading = false
            }
          })
        }
      })
    }
  },
  created () {
    this.handelPre()
    this.logoUrl = this.tenantDetail.company_info.system_logo
    this.tenantData.system_logo = this.tenantDetail.company_info.system_logo_path
    const file = {
      uid: '-1',
      name: '企业LOGO',
      path: this.tenantDetail.company_info.system_logo_path,
      url: this.tenantDetail.company_info.system_logo
    }
    this.fileList.push(file)
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
